'use strict';

/**
 * 
 */

import React from 'react';

class TopicMatrix extends React.Component {

  constructor(props) {
    super(props);

    let tmpTopics = [];

    /** 
    let topics = [
      'Speech and language disorders',
      'Motor function disorders',
      'Mental retardation',
      'Childhood emotional disorders',
      'Autism and other pervasive disorders',
      'Childhood disorders of social functioning',
      'Gender identity disorders',
      'Hyperkinetic and conduct disorders',
      'Scholastic skills disorders',
      'Tic disordersPersonality disorders',
      'Eating disordersSubstance use disorders',
      'Psychotic disorders',
      'Mood disorders',
      'Anxiety disordersDissociative disorders',
      'Obsessive-compulsive disorder',
      'Stress-related disorders',
      'Somatoform and elaboration disorders',
      'Sexual disordersHabit disorders',
      'Sleep disorders',
      'Cognitive disorders'
    ];

    for( var jj in topics ){
      tmpTopics.push( this.createMatrixContentItem( topics[ jj ] )  );
    }
    */
    //matrixContent
    if( typeof props.matrixContent != 'undefined' ){
      tmpTopics = props.matrixContent.topics;
    }

    this.state = {
      'matrixContent' : tmpTopics
		};
    
    this.handleExplainClick = this.handleExplainClick.bind( this );
  }

  componentDidMount() {
    window.appEventsEmitter.emit( 'rendered', { "sourceComponent" : "TopicMatrix" } );
  }
  

  createMatrixContentItem( title ) {
    let heatRnd = Math.floor( Math.random() * 100 );
    let heat = 0;
    

    if( heatRnd > 5 ){
      // heat = 26;
    }
    if( heatRnd > 25 ){
      heat = 26;
    }
    if( heatRnd > 50 ){
      heat = 76;
    }
    if( heatRnd > 80 ){
      heat = 100;
    }

    return {
      'title' : title,
      'progress' : heat, // heat-1
      'infoText' : ' Pikem tekst siia. ' + title + ' Pikem tekst siia. ' + title + title + ' Pikem tekst siia. ' + title
    }
  }

  
  
  createMatrixData( srcData ) {
    let matrix = {
      'rows' : []
    };

    let itemsOnrow = 5;

    let rowCnter = 0;
    let colCnter = 0;

    for( var i in srcData ){
      if( typeof matrix.rows[ rowCnter ] == 'undefined' ){
        matrix.rows[ rowCnter ] = {
          'cols' : []
        }
      }

      matrix.rows[ rowCnter ].cols.push( srcData );

      colCnter++;
      if( colCnter > itemsOnrow ){
        rowCnter++;
        colCnter = 0;
      }
    }


    return matrix;
  }

  handleExplainClick( event, obj ){
    if( typeof this.props.handleMatrixItemClick != 'undefined' ){
      this.props.handleMatrixItemClick( event, obj );
      return;
    }
  }


  render() {
    // let matrixData = this.createMatrixData( this.state.matrixContent );
    var that = this;

    /**
     * 
        <TopicMatrix size="small" withDialogs="0" />
        <TopicMatrix size="full" withDialogs="1" />
    */

    let classes = 'matrix';
    if( this.props.size == 'small' ){
      classes = classes + ' small';
    }
    
    if( typeof this.props.extraClasses != 'undefined' ){
      classes = classes + ' ' + this.props.extraClasses;
    }

    return (
      <div className={classes}>
        {this.state.matrixContent.map( function( obj, index){
          let key = index + new Date().getTime();
          // let loaderKey = 'loadekey-static';
          let heatClass = 'matrix-item heat-' + obj.progress;

          if( that.props.size == 'small' ){
            return (
              <div className={heatClass} key={key} onClick={ ( e ) => that.handleExplainClick( e, obj ) }>
                <div className="matrix-inner">
                </div>
              </div>
            );
          } else {
            return (
              <div className={heatClass} key={key} >
                <div className="matrix-inner">
                  <span className="matrix-item-title"  onClick={ ( e ) => that.handleExplainClick( e, obj ) }>{obj.title}</span>
                </div>
              </div>
            );
          }

        })}
      </div>
    );
  }

}

export default TopicMatrix; 
